import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Icon } from "../../designSystem";

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lt-main">
      <div className="lt-result">
        <span className="lt-result__glyph lt-result__glyph--warning">
          <Icon name="block" style={{ verticalAlign: 0 }} />
        </span>
        <h1>订阅已取消</h1>
        <p className="desc">
          您的订阅流程已取消，未产生任何费用。如果改变主意，随时可以重新订阅。
        </p>

        <div className="actions">
          <Button size="lg" onClick={() => navigate("/subscription/plans")}>
            重新选择订阅
          </Button>
          <Button size="lg" variant="secondary" onClick={() => navigate("/subscription/manage")}>
            管理现有订阅
          </Button>
          <Button size="lg" variant="ghost" onClick={() => navigate("/")}>
            返回首页
          </Button>
        </div>

        <p className="foot">如有任何问题，请联系客服微信：lalambdada</p>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
